import { TimelineMax, TweenMax, Power3 } from 'gsap/TweenMax';


export const pictureInit = (el) => {
  const img = el.querySelector('img');
  TweenMax.set(el, { webkitClipPath: 'inset(100% 50% 0 50%)', clipPath: 'inset(100% 50% 0 50%)' });
  TweenMax.set(img, { scale: 1.5 });
};

export const picture = (el, callback = () => {}) => {
  const img = el.querySelector('img');
  const tl = new TimelineMax({
    onComplete: () => {
      callback();
    },
  });

  tl.addLabel('start')
    .fromTo(el, 1, {
      webkitClipPath: 'inset(100% 50% 0 50%)',
      clipPath: 'inset(100% 50% 0 50%)',
      scaleY: 1.5,
      y: 200,
      autoAlpha: 0,
    }, {
      webkitClipPath: 'inset(0.001% 0.02% 0 0.01%)',
      clipPath: 'inset(0.001% 0.02% 0 0.01%)',
      scaleY: 1,
      y: 0,
      z: 5,
      clearProps: 'webkitClipPath, clipPath, filter',
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 'start')
    .fromTo(img, 0.8, {
      filter: 'brightness(0%) invert(50%)',
      scale: 1.5,
    }, {
      filter: 'brightness(100%) invert(0%)',
      scale: 1,
      z: 5,
      ease: Power3.easeOut,
    }, 'start+=0.3')
    .add(() => {
      el.classList.add('picture--animated');
    }, 'start+=0.8');

  return tl;
};

export const pictureOut = (el, callback = () => {}) => {
  const img = el.querySelector('img');
  const tl = new TimelineMax({
    onComplete: () => {
      if (el.classList.contains('picture--animated')) el.classList.remove('picture--animated');
      callback();
    },
  });

  tl.addLabel('start')
    .set(el, {
      webkitClipPath: 'inset(0.001% 0.02% 0 0.01%)',
      clipPath: 'inset(0.001% 0.02% 0 0.01%)',
    }, 'start')
    .to(el, 1, {
      webkitClipPath: 'inset(100% 50% 0 50%)',
      clipPath: 'inset(100% 50% 0 50%)',
      scaleY: 1.5,
      y: 200,
      autoAlpha: 0,
      clearProps: 'transform',
      ease: Power3.easeOut,
    }, 'start')
    .to(img, 0.8, {
      filter: 'brightness(0%) invert(50%)',
      scale: 1.5,
      clearProps: 'transform',
      ease: Power3.easeOut,
    }, 'start+=0.3');

  return tl;
};

export function pictureLoad(el) {
  const img = el.querySelector('.picture__image');

  return new Promise((resolve, reject) => {
    const image = new Image();
    let src = '';

    src = img.getAttribute('data-src');

    image.src = src;

    img.removeAttribute('data-src');

    const errorHandler = () => {
      reject(new Error(`Failed to load image's URL: ${src}`));
    };

    const imageHandler = () => {
      image.removeEventListener('load', imageHandler);
      image.removeEventListener('error', errorHandler);
      img.src = image.src;
      image.remove();

      resolve();
    };

    image.addEventListener('load', imageHandler());
    image.addEventListener('error', errorHandler());
  }).then(() => {
    picture(el, img);
  });
}
